import { routerMain } from 'constants/routerMain';
import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import ring from 'assets/images/icon/6326044_preview.png';
import releaseApi from 'api/releaseApi';
import { useApp } from 'context/AppContext';
import { notification } from 'constants/notification';
import { formatDateTime } from 'helpers/date/formatDateTime';

import { useIntl } from 'react-intl';
import { Routes, RoutesEContract } from './router';
import { selectAuth, selectUser } from 'app/slice/authSlice';
import { APP_ECONTRACT } from 'constants/global';
import capacityUsedApi from 'api/capacityUsedApi';
import ModalWarningCert from 'components/Modal/ModalWarningCert';
import ModalWarningPackage from 'components/Modal/ModalWarningPackage';

const AppRouter = () => {
    const userPer = useSelector(selectUser);
    const authData = useSelector(selectAuth);

    const history = useHistory();
    const intl = useIntl();
    const { keycloak } = useKeycloak();
    const { showAlert } = useApp();

    const [isWarnCert, setIsWarnCert] = useState(false);
    const [isWarnPackage, setIsWarnPackage] = useState(false);
    const [dataCert, setDataCert] = useState();
    const [dataPackage, setDataPackage] = useState();

    const getNewVer = async () => {
        try {
            const result = await releaseApi.getActiveVersion();
            if (result) {
                const { data, status, message } = result;
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                    return;
                }
                if (status === 1) {
                    handleNotiVer(data.name, data.release_at, data.uuid);
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const getWarningPackage = async () => {
        try {
            const result = await capacityUsedApi.getWarningPackage();
            if (result) {
                const { data, status, message } = result;
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                    return;
                }
                if (status === 1) {
                    setDataPackage((pre) => ({
                        ...pre,
                        ...data,
                    }));
                    if (data.isWarnPackage && data.checkPackage) {
                        setIsWarnPackage(true);
                    }
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const getWarningCert = async () => {
        try {
            const result = await capacityUsedApi.getWarningCert();
            if (result) {
                const { data, status, message } = result;
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                    return;
                }
                if (status === 1) {
                    setDataCert((pre) => ({
                        ...pre,
                        ...data,
                    }));
                    if (data.isWarnCert && data.checkCert) {
                        setIsWarnCert(true);
                    }
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const handleViewNewVer = (uuid) => {
        history.push('/thong-bao-phat-hanh', { uuid: uuid });
    };
    const handleNotiVer = (ver, time, uuid) => {
        const AppName = authData?.app === APP_ECONTRACT ? 'xCyber Contract' : 'xCyber Doc';

        Swal.fire({
            title: intl.formatMessage({ id: 'ChangeLog.Dialog.title' }),
            html: `<span>${intl.formatMessage({
                id: 'ChangeLog.Dialog.content',
            })} <span class="text-primary">${AppName} ${ver}</span> ${intl.formatMessage({
                id: 'at',
            })} <span class="text-primary">${formatDateTime(time)}</span></span>`,
            icon: 'info',
            iconHtml: `<img src="${ring}" width=50px>`,
            showCancelButton: true,
            cancelButtonText: intl.formatMessage({ id: 'closepopup' }),
            confirmButtonText: intl.formatMessage({ id: 'view-detail' }),
            customClass: {
                confirmButton: 'p-button p-component p-button-success p-ml-2',
                cancelButton: 'p-button p-component p-button-raised p-button-danger',
                icon: 'no-border',
            },
            buttonsStyling: false,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                handleViewNewVer(uuid);
            }
        });
    };

    useEffect(() => {
        if (!keycloak.authenticated) {

            keycloak.login();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keycloak]);

    useEffect(() => {
        if (authData.app !== APP_ECONTRACT) {
            userPer?.data?.view_changelog === 1 && getNewVer();
        }

        userPer?.data?.is_view_quick_create === 1 && history.push(routerMain.QUICK_WIZARD);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authData, userPer]);

    useEffect(() => {
        if (userPer) {
            Promise.all(
                getWarningCert(),
                getWarningPackage(),
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPer]);

    const RouterMain = authData.app === APP_ECONTRACT ? RoutesEContract : Routes;

    return (
        <>
            <Switch>
                {RouterMain.map((route, i) => {
                    if (route.hasOwnProperty('redirect_path')) {
                        return (
                            <Route key={route.path} path={route.path} exact={route.exact}>
                                <Redirect to={route.redirect_path} />
                            </Route>
                        );
                    } else
                        return (
                            <Route
                                path={route.path}
                                exact={route.exact}
                                key={route.path}
                                render={(props) => {
                                    return (
                                        // pass the sub-routes down to keep nesting
                                        <route.component {...props} />
                                    );
                                }}
                            ></Route>
                        );
                })}
            </Switch>

            <ModalWarningCert isOpen={isWarnCert} setIsOpen={setIsWarnCert} data={dataCert} />
            <ModalWarningPackage isOpen={isWarnPackage} setIsOpen={setIsWarnPackage} data={dataPackage} />
        </>
    );
};

export default AppRouter;
